import * as React from 'react';
import { humanize } from '@utils';
import BaseChart, { useChartInstance } from '@src/components/common/BaseChart';
import { formatGaugeChartData, getThresholds, getTextColor } from '../../../utils';
import { GaugeContainer, GaugeValue } from './styled';

export interface GaugeProps {
  value: number;
  settings: {
    threshold: {
      t1?: number;
      t2?: number;
    };
    timeout?: number;
    timeout_unit?: string;
  };
}

const Gauge = ({ value, settings }: GaugeProps) => {
  const { instance, chartInstanceRefCb } = useChartInstance({});
  const thresholds = getThresholds(settings);
  const scoreColor = getTextColor(value || 0, thresholds.absolute);

  const chartOption = React.useMemo(
    () => formatGaugeChartData(humanize(value, ''), thresholds.scaled),
    [value, thresholds.scaled],
  );

  React.useEffect(() => {
    if (instance) {
      instance.setOption(chartOption);
    }
  }, [instance, chartOption]);

  return (
    <GaugeContainer>
      <BaseChart chartInstanceRefCb={chartInstanceRefCb} style={{ width: 40, height: 42 }} />
      <GaugeValue style={{ color: scoreColor }}>{humanize(value, '')} %</GaugeValue>
    </GaugeContainer>
  );
};

export default Gauge;
